import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import formReducer from 'redux-form/es/reducer';
import { reducer as toastrReducer } from 'react-redux-toastr';
import authentication from './authentication';
import localization from './localization';
import selfservice from './selfservice';
import marketingConsents from './marketingConsents';
import analytics from './analytics';

const reducers = {
  authentication,
  routing,
  selfservice,
  marketingConsents,
  form: formReducer,
  intl: localization,
  toastr: toastrReducer,
};

if (COUNTRY === 'FI' || COUNTRY === 'CZ') {
  reducers.analytics = analytics;
}
export default combineReducers(reducers);
